import { render, staticRenderFns } from "./tabPositions.vue?vue&type=template&id=d5369832&scoped=true"
import script from "./tabPositions.vue?vue&type=script&lang=js"
export * from "./tabPositions.vue?vue&type=script&lang=js"
import style0 from "./tabPositions.vue?vue&type=style&index=0&id=d5369832&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5369832",
  null
  
)

export default component.exports